import { render, staticRenderFns } from "./AdjusterPortalList.vue?vue&type=template&id=f8f9f11e"
import script from "./AdjusterPortalList.vue?vue&type=script&lang=ts"
export * from "./AdjusterPortalList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports